import { Pipe, PipeTransform } from "@angular/core";
import { Appointment, IParticipant } from "@comunicare/comunicare-interfaces";

@Pipe({ name: "teleconsultationLastConnection" })
export class TeleconsultationLastConnectionPipe implements PipeTransform {
  public transform(participants: IParticipant[], patient = true): string {
    return patient
      ? participants?.find((p) => p.participantType.text === Appointment.PERSON)?.lastConnection ?? ""
      : participants?.find((p) => p.participantType.text === Appointment.PRACTITIONER)?.lastConnection ?? "";
  }
}
